import React, { useEffect, useState } from "react";

import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import RecordPerPage from "../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import {
  details,
  setDetails,
  deleteRecord,
  fetchList,
  setPerPage,
} from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
import ViewDrawer from "./components/ViewDrawer";
import AddComponent from "./components/Form/AddComponent";
import EditComponent from "./components/Form/EditComponent";
import { RoleBreadcrumb } from "../../../config/BreadcrumbConfig";
import { CONSTANT } from "../../../config/Constant";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
import { toUpperCaseWithUnderscore } from "../../../utils/commonFunctions";
import { setEditLoading, setViewLoading } from "../../../store/CommonSlice";

const moduleInfo = {
  title: "Role",
  permissionKeyPrefix: toUpperCaseWithUnderscore("Roles"),
};

/**
 * Renders the RoleManagement component.
 *
 * @return {ReactElement} The rendered RoleManagement component.
 */
const RoleManagement: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { perPage } = useAppSelector((state) => state.role);
  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [viewDrawer, setViewDrawer] = useState(false);
  const [deleteValue, setDeleteValue] = useState<any>();

  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);

  /**
   *  set loading on action button click and dispatch details 
   * api call and set loading to false on success and open drawer.
   * and throw error on failure.
    */ 
  const getDetails = (data: any, type: string) => {
    if (type === CONSTANT.DRAWER_TYPE.VIEW) {
      dispatch(setViewLoading([true, data.id]));
    } else {
      dispatch(setEditLoading([true, data.id]));
    }
    dispatch(details(data.id))
      .then(() => {
        if (type === CONSTANT.DRAWER_TYPE.VIEW) {
          setViewDrawer(true);
          dispatch(setViewLoading([false, data.id]));
        }
        if (type === CONSTANT.DRAWER_TYPE.EDIT) {
          setEditDrawer(true);
          dispatch(setEditLoading([false, data.id]));
        }
      })
      .catch((error: any) => error);
  };
  return (
    <>
      <ToolBar breadcrumbs={RoleBreadcrumb}>
        <CreateButton
          action={() => setIsCreateVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
        <RecordPerPage
          perPage={perPage}
          onChange={(perPageSize: number) => {
            dispatch(setPerPage(perPageSize));
          }}
        />
      </ToolBar>
      <ContentBox>
        <Listing
          moduleInfo={moduleInfo}
          handleViewClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}
          handleEditClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.EDIT);
          }}
          handleDeleteClick={setDeleteValue}
        />
        <AddComponent
          titleName={moduleInfo.title}
          open={isCreateVisible}
          close={() => setIsCreateVisible(false)}
        />
        <ViewDrawer
          titleName={moduleInfo.title}
          open={viewDrawer}
          close={() => dispatch(setDetails(null)) && setViewDrawer(false)}
        />
        <EditComponent
          titleName={moduleInfo.title}
          open={editDrawer}
          close={() => dispatch(setDetails(null)) && setEditDrawer(false)}
        />
        <DeleteModal
          title={moduleInfo.title}
          deleteValues={deleteValue}
          callApi={deleteRecord}
          close={() => setDeleteValue(null)}
        />
      </ContentBox>
    </>
  );
};

export default RoleManagement;
